import 'jquery';
import '../utils/slick.js';

$(function () {
  var sections = $('.hv2-resources');

  sections.each(function () {
    var section = $(this);
    var slider = section.find('.hv2-resources__list');
    var resources = section.find('.hv2-resources__card');

    function initSlider() {
      slider.slick({
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        responsive: [
          {
            breakpoint: 599,
            settings: {
              centerPadding: '10%'
            }
          }
        ]
      });
    }

    function destroySlider() {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
    }

    function removeSalAnimate() {
      resources.each(function () {
        $(this).removeClass('sal-animate');
        $(this).removeAttr('data-sal');
        $(this).removeAttr('data-sal-duration');
        $(this).removeAttr('data-sal-delay');
      });
    }

    function handleResize() {
      var isMobile = $(window).width() <= 767;

      if (isMobile && !slider.hasClass('slick-initialized')) {
        removeSalAnimate();
        initSlider();
      } else if (!isMobile && slider.hasClass('slick-initialized')) {
        destroySlider();
      }
    }

    handleResize();

    window.addEventListener('resize', function () {
      setTimeout(function () {
        handleResize();
      }, 100);
    });
  });
});
